import qs from 'query-string';
import { map } from 'lodash';
import {
  ListThemeCategoryGetByFrameIdPhotoRequestModel,
  ListThemeCategoryPhotoRequestModel,
  ListThemeCategoryPhotoResponseModel,
  ThemeCategoryPhotoStateModel,
} from 'models/photo/theme-category.model';
import { PREFIX_API } from 'constants/api.const';
import { baseSliceApi } from './base.slice-api';

export const themeCategoryApi = baseSliceApi.injectEndpoints({
  endpoints: (build) => ({
    listThemeCategoryApiAction: build.query<
      ThemeCategoryPhotoStateModel['listThemeCategoryPhotos'],
      ListThemeCategoryPhotoRequestModel
    >({
      query: (payload) => ({
        url: `${PREFIX_API.API}/theme-categories/getlist?${qs.stringify(
          payload,
        )}`,
      }),
      providesTags: (data) => [
        ...map(
          data?.data,
          ({ id }) => ({ type: 'ThemeCategoryPhoto', id } as const),
        ),
        { type: 'ThemeCategoryPhoto' as const, id: 'LIST' },
      ],
      transformResponse: (rawResult: ListThemeCategoryPhotoResponseModel) => ({
        data: rawResult?.response?.data ?? [],
        totalRecord: rawResult?.response?.totalRecord ?? 0,
      }),
      extraOptions: { maxRetries: 1 },
    }),
    listThemeCategoryByFrameIdApiAction: build.query<
      ThemeCategoryPhotoStateModel['listThemeCategoryPhotos'],
      ListThemeCategoryGetByFrameIdPhotoRequestModel
    >({
      query: (payload) => ({
        url: `${
          PREFIX_API.API
        }/theme-categories/getlistbyframeid?${qs.stringify(payload)}`,
      }),
      providesTags: (data) => [
        ...map(
          data?.data,
          ({ id }) => ({ type: 'ThemeCategoryPhoto', id } as const),
        ),
        { type: 'ThemeCategoryPhoto' as const, id: 'LIST' },
      ],
      transformResponse: (rawResult: ListThemeCategoryPhotoResponseModel) => ({
        data: rawResult?.response?.data ?? [],
        totalRecord: rawResult?.response?.totalRecord ?? 0,
      }),
      extraOptions: { maxRetries: 1 },
    }),
  }),
});

export const {
  useListThemeCategoryApiActionQuery,
  useLazyListThemeCategoryApiActionQuery,
  useListThemeCategoryByFrameIdApiActionQuery,
  useLazyListThemeCategoryByFrameIdApiActionQuery,
} = themeCategoryApi;

export const {
  endpoints: { listThemeCategoryApiAction },
} = themeCategoryApi;
